import { FC } from 'react';

import { Button } from 'ui/components/common';
import { CheckIcon } from 'ui/components/icon';
import { cn } from 'utils/helpers';

type Props = {
  isComplete: boolean;
  handleToggle: (isComplete?: boolean) => void;
  disabled?: boolean;
  ['data-tut']?: string;
};

const MarkAsComplete: FC<Props> = ({
  handleToggle,
  disabled,
  'data-tut': dataTut,
  isComplete,
}) => {
  return (
    <Button
      className={cn(
        'rounded-md',
        !isComplete &&
          'outline hover:text-primary-base hover:outline-primary-base',
        'py-[6px] px-2',
      )}
      data-tut={dataTut}
      intent={isComplete ? 'primary' : 'tertiary'}
      left
      label={isComplete ? 'Completed' : 'Mark complete'}
      icon={CheckIcon}
      type="button"
      disabled={disabled}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        handleToggle();
      }}
    />
  );
};

export default MarkAsComplete;
